// extracted by css-extract-rspack-plugin
var _1 = "hvyVgyVkosvtYCSm";
var _2 = "h9Hn87qUreILzk1C";
export { _1 as "hiddenDesktop", _2 as "hiddenMobile" }
